if (!window.timondSizeChartEventsBound) {
  window.timondSizeChartEventsBound = true;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.timond-size-chart__trigger');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (typeof dialog?.showModal === 'function') {
        dialog.timondOpener = trigger;
        dialog.showModal();
      }
      return;
    }
    const close = event.target.closest('[data-size-chart-close]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }
    if (!event.target.matches('.timond-size-chart__dialog')) return;
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }, true);
  document.addEventListener('close', event => {
    if (event.target.matches('.timond-size-chart__dialog') && event.target.timondOpener?.isConnected) {
      event.target.timondOpener.focus({ preventScroll: true });
    }
  }, true);
}

if (!customElements.get('timond-size-chart')) {
  customElements.define('timond-size-chart', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section');
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.timond-size-chart__trigger')
        || this.scope?.querySelector(`.timond-size-chart__trigger[aria-controls="${this.dialog?.id}"]`);
      if (!this.dialog || !this.trigger) return;

      // The native picker can be replaced on variant change; Teeinblue mounts later.
      this.placeTrigger();
      this.observer = new MutationObserver(() => {
        if (this.placeQueued) return;
        this.placeQueued = true;
        requestAnimationFrame(() => {
          this.placeQueued = false;
          this.placeTrigger();
        });
      });
      if (this.scope) this.observer.observe(this.scope, { childList: true, subtree: true });
    }

    placeTrigger() {
      if (!this.scope || !this.trigger) return;
      const personalizedTitle = this.scope.querySelector('.tee-option--size .tee-option__title');
      if (personalizedTitle) {
        if (this.trigger.previousElementSibling !== personalizedTitle) personalizedTitle.after(this.trigger);
        this.trigger.hidden = false;
        this.trigger.dataset.location = 'teeinblue';
        return;
      }
      const sizeFieldset = [...this.scope.querySelectorAll('variant-picker fieldset.variant-option')]
        .find(fieldset => [...fieldset.querySelectorAll('input[data-option-name]')]
          .some(input => /^(gr[oö]ße|groesse|size)$/i.test(input.dataset.optionName?.trim() || '')));
      if (sizeFieldset) {
        const legend = sizeFieldset.querySelector('legend');
        if (legend && this.trigger.parentElement !== legend) legend.append(this.trigger);
        sizeFieldset.classList.add('timond-size-chart__field');
        sizeFieldset.setAttribute('aria-label', sizeFieldset.querySelector('input[data-option-name]')?.dataset.optionName || 'Größe');
        this.trigger.hidden = false;
        this.trigger.dataset.location = 'variant';
        return;
      }
      const sizeSelect = [...this.scope.querySelectorAll('variant-picker .variant-option--dropdowns')]
        .find(option => /^(gr[oö]ße|groesse|size)$/i.test(option.querySelector('label')?.textContent.trim() || ''));
      if (sizeSelect) {
        const label = sizeSelect.querySelector('label');
        if (label && this.trigger.previousElementSibling !== label) label.after(this.trigger);
        this.trigger.hidden = false;
        this.trigger.dataset.location = 'dropdown';
      } else {
        this.trigger.hidden = true;
        if (!this.contains(this.trigger)) this.prepend(this.trigger);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
      if (this.trigger?.isConnected && !this.contains(this.trigger)) this.prepend(this.trigger);
    }
  });
}
